import { Divider } from '@repo/editor/src/components/utilities/styles';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

import { NAVBAR_QUERIES } from '../utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    display: grid;
    grid-column-gap: 12px;
    grid-template-columns: repeat(2, 1fr);
  }

  ${QUERIES.laptopAndUp} {
    grid-template-columns: repeat(4, 1fr);
  }

  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;

export const MobileDivider = styled(Divider)`
  color: ${themeStyle.varInkSuperLight};

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }

  &:first-child {
    display: none;
  }
`;

export const LinkColumnWrapper = styled.div<{ columnsCount: number }>`
  grid-column: ${({ columnsCount }) => `span ${columnsCount}`};
`;

export const LinkColumnElementsWrapper = styled.div<{
  columnsCount: number;
  small: boolean;
}>`
  width: 100%;
  display: ${({ small }) => (small ? 'block' : 'grid')};

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    gap: 12px;
  }

  ${NAVBAR_QUERIES.headerTabletMinWidth} {
    grid-template-columns: ${({ columnsCount, small }) =>
      small ? 'none' : `repeat(${columnsCount}, minmax(0, 1fr))`};
  }
`;

export const LinkWrapper = styled(FlexRow)<{
  small: boolean;
}>`
  align-items: center;
  gap: 12px;
  justify-content: ${({ small }) => (small ? 'space-between' : 'flex-start')};
  width: 100%;
`;

export const LabelWrapper = styled.div`
  width: 100%;
  padding: 8px;

  ${QUERIES.largeTabletAndUp} {
    padding: 12px 8px;
  }
`;

export const HighlightOnHover = styled.div`
  display: inline-block;
  padding: 7.5px 12px;
  border-radius: ${themeStyle.radiusMedium};
  width: 100%;
  cursor: pointer;

  color: ${themeStyle.varInkMedium};
  @media (hover: hover) {
    &:hover {
      background: ${themeStyle.varInkSuperLight};
      color: ${themeStyle.varInkMain};
    }
  }
`;

export const MenuItemDescription = styled.div`
  text-wrap: auto;
`;
